import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
} from "redux/helpers/fetching"
import {
  fetchProducts,
  fetchProduct,
} from "redux/features/product/productThunk"

const productAdapter = createEntityAdapter()
export const initialState = productAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
  fetchCollectionStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchProduct.pending, (state) => handleFetchPending(state))
      .addCase(fetchProduct.rejected, (state) => handleFetchRejected(state))
      .addCase(fetchProduct.fulfilled, (state, { payload }) => {
        productAdapter.setOne(state, payload)
        handleFetchFulfilled(state)
      })
      .addCase(fetchProducts.pending, (state) =>
        handleCollectionFetchPending(state),
      )
      .addCase(fetchProducts.rejected, (state) =>
        handleCollectionFetchRejected(state),
      )
      .addCase(fetchProducts.fulfilled, (state, { payload }) => {
        productAdapter.setAll(state, payload)
        handleCollectionFetchFulfilled(state)
      })
  },
})

export const {
  selectAll: selectProducts,
  selectTotal,
  selectById: selectProductById,
} = productAdapter.getSelectors((state: RootState) => state.features.product)

export const selectFetchStatus = (state: RootState) =>
  state.features.product.fetchStatus
export const selectFetchCollectionStatus = (state: RootState) =>
  state.features.product.fetchCollectionStatus

export default productSlice.reducer
